import { ProductBonus } from '@product/const';
import { StateUtils } from '@spartacus/core';
import { CustomProductActions } from '../actions';

export const initialState: ProductBonus[] = undefined;

export function reducer(
  state = initialState,
  action: StateUtils.LoaderAction | CustomProductActions.SetBonuses | CustomProductActions.LoadBonusesSuccess,
): ProductBonus[] {
  switch (action.type) {
    case CustomProductActions.LOAD_BONUSES_SUCCESS:
    case CustomProductActions.SET_BONUSES: {
      const { payload } = action;

      return payload;
    }

    default: {
      return state;
    }
  }
}
